import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";
import useToken from "../helpers/useToken";
import NotificationAlert from "react-notification-alert";
import TMHLoader from "../components/TMHLoader/TMHLoader";

export default function Config() {
  const { token } = useToken();
  const [rokuConfig, setRokuConfig] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const notificationAlertRef = useRef(null);

  const notify = (place, message, type = 1, autoDismiss = 5) => {
    let options = {
      place: place,
      message: <div>{message}</div>,
      type: type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: autoDismiss,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  useEffect(() => {
    const initData = () => {
      setIsLoading(true);
      console.log("EditRokuConfig: get data");
      const myHeaders = new Headers();
      myHeaders.append("Cache-Control", "no-cache");
      myHeaders.append("Access-Token", token);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
      };

      fetch(process.env.REACT_APP_BASE_URL + "roku_config", requestOptions)
        .then((response) => {
          return new Promise((resolve) =>
            response.json().then((json) =>
              resolve({
                status: response.status,
                ok: response.ok,
                json,
              })
            )
          );
        })
        .then((result) => {
          var json = result.json;
          // console.log(json)
          if (result.ok) {
            setRokuConfig(json);
          } else {
            // console.log(result.json.message)
          }
          setIsLoading(false);
        });
    };

    initData();
    document.title = "Roku Config - TMH Admin";
  }, [token]);

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    console.log("EditRokuConfig: PUT data");
    const myHeaders = new Headers();
    myHeaders.append("Cache-Control", "no-cache");
    myHeaders.append("Access-Token", token);
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: JSON.stringify(rokuConfig),
    };

    fetch(process.env.REACT_APP_BASE_URL + "roku_config", requestOptions)
      .then((response) => {
        return new Promise((resolve) =>
          response.json().then((json) =>
            resolve({
              status: response.status,
              ok: response.ok,
              json,
            })
          )
        );
      })
      .then(async (result) => {
        var json = result.json;
        // console.log(json)
        if (result.ok) {
          setRokuConfig(json);
          notify("tl", "Save Config Success!", "success");
        } else {
          // console.log(result.json.message)
          notify("tl", "Save Config Failed: !" + json?.message, "danger");
        }
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="content">
        <div className="react-notification-alert-container">
          <NotificationAlert ref={notificationAlertRef} />
        </div>
        <TMHLoader active={isLoading}>
          <Row>
            <Col>
              <Card>
                <CardHeader>
                  <h3 className="title">ADMIN SECTION FOR API CALLS EDITOR</h3>
                </CardHeader>
                <CardBody>
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col className="pr-md-1" md="4">
                        <FormGroup>
                          <label>
                            Content Minutes Before get Completed Bonus
                          </label>
                          <Input
                            onChange={(e) =>
                              setRokuConfig({
                                ...rokuConfig,
                                mins_watching: e.target.value,
                              })
                            }
                            placeholder="Content Minutes Before get Completed Bonus"
                            value={rokuConfig ? rokuConfig.mins_watching : 0}
                            type="number"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="pr-md-1" md="4">
                        <FormGroup>
                          <label htmlFor="exampleInputEmail1">
                            VIP Ad tag url
                          </label>
                          <Input
                            onChange={(e) =>
                              setRokuConfig({
                                ...rokuConfig,
                                ad_tag_url: e.target.value,
                              })
                            }
                            placeholder="VIP Ad tag url"
                            value={rokuConfig ? rokuConfig.ad_tag_url : ""}
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                      <Col className="pl-md-1" md="4">
                        <FormGroup>
                          <label htmlFor="exampleInputEmail1">
                            Organic Ad tag url
                          </label>
                          <Input
                            onChange={(e) =>
                              setRokuConfig({
                                ...rokuConfig,
                                organic_ad_tag_url: e.target.value,
                              })
                            }
                            placeholder="Organic Ad tag url"
                            value={
                              rokuConfig ? rokuConfig.organic_ad_tag_url : ""
                            }
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="2">
                        <h3>
                          Organic <br /> users
                        </h3>
                      </Col>
                      <Col className="pr-md-1" sm="3" md="2">
                        <FormGroup>
                          <label>Watch mins to 100%</label>
                          <Input
                            onChange={(e) =>
                              setRokuConfig({
                                ...rokuConfig,
                                organic: {
                                  ...rokuConfig.organic,
                                  minutes_to_100: parseInt(e.target.value),
                                },
                              })
                            }
                            placeholder="Watch mins to 100%"
                            value={
                              rokuConfig
                                ? rokuConfig.organic?.minutes_to_100
                                : ""
                            }
                            type="number"
                          />
                        </FormGroup>
                      </Col>
                      <Col className="pr-md-1" md="2">
                        <FormGroup>
                          <label>Mins play between ad call</label>
                          <Input
                            onChange={(e) =>
                              setRokuConfig({
                                ...rokuConfig,
                                organic: {
                                  ...rokuConfig.organic,
                                  minutes_between: parseInt(e.target.value),
                                },
                              })
                            }
                            placeholder="Watch mins to 100%"
                            value={
                              rokuConfig
                                ? rokuConfig.organic?.minutes_between
                                : ""
                            }
                            type="number"
                          />
                        </FormGroup>
                      </Col>
                      <Col className="pr-md-1" md="1">
                        <FormGroup className="text-center">
                          <label>Pre roll?</label>
                          <br />
                          <Button
                            onClick={() =>
                              setRokuConfig({
                                ...rokuConfig,
                                organic: {
                                  ...rokuConfig.organic,
                                  pre_roll: !rokuConfig.organic.pre_roll,
                                },
                              })
                            }
                            className="btn-icon btn-simple"
                            color={
                              rokuConfig?.organic?.pre_roll
                                ? "success"
                                : "warning"
                            }
                            size="sm"
                          >
                            {rokuConfig?.organic?.pre_roll && (
                              <i className="fa fa-check"></i>
                            )}
                          </Button>
                        </FormGroup>
                      </Col>
                      <Col className="pr-md-1" md="2">
                        <FormGroup>
                          <label>Are you still watching notif</label>
                          <Input
                            onChange={(e) =>
                              setRokuConfig({
                                ...rokuConfig,
                                organic: {
                                  ...rokuConfig.organic,
                                  still_watching_minutes: parseInt(
                                    e.target.value
                                  ),
                                },
                              })
                            }
                            placeholder="Still watching minutes"
                            value={
                              rokuConfig
                                ? rokuConfig.organic?.still_watching_minutes
                                : ""
                            }
                            type="number"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="1" />
                      <Col
                        md="7"
                        className="mb-4"
                        style={{
                          border: "1px solid",
                        }}
                      />
                    </Row>
                    {rokuConfig && (
                      <>
                        {rokuConfig.rounds.map((round, index) => {
                          return (
                            <Row key={index}>
                              <Col md="2">
                                <h3>
                                  {" "}
                                  {index === 0 ? "VIPs" : ""} <br /> Round{" "}
                                  {index + 1}{" "}
                                  {rokuConfig?.rounds.length === index + 1 && (
                                    <>+</>
                                  )}{" "}
                                </h3>
                              </Col>
                              <Col className="pr-md-1" sm="3" md="2">
                                <FormGroup>
                                  <label>Watch mins to 100%</label>
                                  <Input
                                    onChange={(e) => {
                                      let rokuConfigTemp = { ...rokuConfig };
                                      rokuConfigTemp.rounds[
                                        index
                                      ].minutes_to_100 = parseInt(
                                        e.target.value
                                      );
                                      setRokuConfig(rokuConfigTemp);
                                    }}
                                    value={
                                      rokuConfig
                                        ? rokuConfig.rounds[index]
                                            .minutes_to_100
                                        : ""
                                    }
                                    type="number"
                                  />
                                </FormGroup>
                              </Col>
                              <Col className="pr-md-1" md="2">
                                <FormGroup>
                                  <label>Mins play between ad call</label>
                                  <Input
                                    onChange={(e) => {
                                      let rokuConfigTemp = { ...rokuConfig };
                                      rokuConfigTemp.rounds[
                                        index
                                      ].minutes_between = parseInt(
                                        e.target.value
                                      );
                                      setRokuConfig(rokuConfigTemp);
                                    }}
                                    value={
                                      rokuConfig
                                        ? rokuConfig.rounds[index]
                                            .minutes_between
                                        : ""
                                    }
                                    type="number"
                                  />
                                </FormGroup>
                              </Col>
                              <Col className="pr-md-1" md="1">
                                <FormGroup className="text-center">
                                  <label>Pre roll?</label>
                                  <br />
                                  <Button
                                    onClick={() => {
                                      let rokuConfigTemp = { ...rokuConfig };
                                      rokuConfigTemp.rounds[index].pre_roll =
                                        !rokuConfigTemp.rounds[index].pre_roll;
                                      setRokuConfig(rokuConfigTemp);
                                    }}
                                    className="btn-icon btn-simple"
                                    color={
                                      rokuConfig.rounds[index].pre_roll
                                        ? "success"
                                        : "warning"
                                    }
                                    size="sm"
                                  >
                                    {rokuConfig.rounds[index].pre_roll && (
                                      <i className="fa fa-check"></i>
                                    )}
                                  </Button>
                                </FormGroup>
                              </Col>
                              <Col className="pr-md-1" md="2">
                                <FormGroup>
                                  <label>Are you still watching notify</label>
                                  <Input
                                    onChange={(e) => {
                                      let rokuConfigTemp = { ...rokuConfig };
                                      rokuConfigTemp.rounds[
                                        index
                                      ].still_watching_minutes = parseInt(
                                        e.target.value
                                      );
                                      setRokuConfig(rokuConfigTemp);
                                    }}
                                    value={
                                      rokuConfig
                                        ? rokuConfig.rounds[index]
                                            .still_watching_minutes
                                        : ""
                                    }
                                    type="number"
                                  />
                                </FormGroup>
                              </Col>
                              {rokuConfig?.rounds.length === index + 1 && (
                                <>
                                  <Col md="1" className="text-center">
                                    <label>Copy round</label>
                                    <br />
                                    <Button
                                      onClick={() => {
                                        let rokuConfigTemp = { ...rokuConfig };
                                        rokuConfigTemp.rounds.push({
                                          ...rokuConfigTemp.rounds[index],
                                        });
                                        setRokuConfig(rokuConfigTemp);
                                      }}
                                      className="btn-icon btn-simple"
                                      color="success"
                                      size="sm"
                                    >
                                      <i className="fa-regular fa-clone"></i>
                                    </Button>
                                  </Col>
                                  <Col md="1" className="text-center">
                                    <label>Remove round</label>
                                    <br />
                                    <Button
                                      onClick={() => {
                                        let rokuConfigTemp = { ...rokuConfig };
                                        rokuConfigTemp.rounds.pop();
                                        setRokuConfig(rokuConfigTemp);
                                      }}
                                      className="btn-icon btn-simple"
                                      color="danger"
                                      size="sm"
                                    >
                                      <i className="fa-solid fa-square-minus"></i>
                                    </Button>
                                  </Col>
                                </>
                              )}
                            </Row>
                          );
                        })}
                      </>
                    )}
                    <Row>
                      <Col md="1" />
                      <Col
                        md="7"
                        className="mb-4"
                        style={{
                          border: "1px solid",
                        }}
                      />
                    </Row>
                    <Row>
                      <Col md="5">
                        <h3> Frequency Setup </h3>
                      </Col>
                      <Col md="6">
                        <h3> Frequency Setup V2 </h3>
                      </Col>
                    </Row>
                    {rokuConfig && (
                      <>
                        {rokuConfig.frequency_list.map((_, index) => {
                          return (
                            <Row key={index}>
                              <Col md="2">
                                <h3>
                                  {" "}
                                  {rokuConfig.frequency_list[index].name}{" "}
                                </h3>
                              </Col>
                              <Col className="pr-md-1" sm="3" md="2">
                                <FormGroup>
                                  <label>Frequency per 1000 spins</label>
                                  <Input
                                    onChange={(e) => {
                                      let rokuConfigTemp = {
                                        ...rokuConfig,
                                      };
                                      rokuConfigTemp.frequency_list[
                                        index
                                      ].frequency_number = parseInt(
                                        e.target.value
                                      );
                                      setRokuConfig(rokuConfigTemp);
                                    }}
                                    value={
                                      rokuConfig
                                        ? rokuConfig.frequency_list[index]
                                            .frequency_number
                                        : ""
                                    }
                                    type="number"
                                  />
                                </FormGroup>
                              </Col>
                              {rokuConfig.frequency_list2 &&
                                rokuConfig.frequency_list2[index] && (
                                  <>
                                    <Col md="1" />
                                    <Col md="2">
                                      <h3>
                                        {" "}
                                        {
                                          rokuConfig.frequency_list2[index].name
                                        }{" "}
                                      </h3>
                                    </Col>
                                    <Col className="pr-md-1" sm="3" md="2">
                                      <FormGroup>
                                        <label>Frequency per 1000 spins</label>
                                        <Input
                                          onChange={(e) => {
                                            let rokuConfigTemp = {
                                              ...rokuConfig,
                                            };
                                            rokuConfigTemp.frequency_list2[
                                              index
                                            ].frequency_number = parseInt(
                                              e.target.value
                                            );
                                            setRokuConfig(rokuConfigTemp);
                                          }}
                                          value={
                                            rokuConfig
                                              ? rokuConfig.frequency_list2[
                                                  index
                                                ].frequency_number
                                              : ""
                                          }
                                          type="number"
                                        />
                                      </FormGroup>
                                    </Col>
                                  </>
                                )}
                            </Row>
                          );
                        })}
                      </>
                    )}
                    <div className="text-center">
                      <Button
                        className="btn-fill"
                        color="success"
                        type="submit"
                      >
                        Save
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </TMHLoader>
      </div>
    </>
  );
}
